define('datepicker',[
    // Libs
    'services/i18n',
    'jquery',
    'bootstrap-datepicker',
    'bootstrap-datepicker-fr',
], function(i18n, $) {
    $.fn.datepicker.defaults.format = "yyyy/mm/dd";
    $.fn.datepicker.defaults.startView = 0;
    $.fn.datepicker.defaults.weekStart = 1;
    $.fn.datepicker.defaults.language = "en";//i18n.language.substring(0, 2);
    $.fn.datepicker.dates.fr.format = "yyyy/mm/dd";

    return $;
});

